import { useCustomMaterials } from "#modules/materials/view/useCustomMaterials";
import { getMaterialDimensionsSelectOptions } from "#modules/quoteRequestLines/domain/getMaterialDimensionsSelectOptions";
import { FormatterMaterialParameter, MaterialGradeType, PartTypeType } from "shared";

export const useDimensionOptions = ({
  materialGrade,
  materialName,
  partType,
  partSubType,
  partDimensionsWithOverthickness,
}: {
  materialGrade: MaterialGradeType;
  partType: PartTypeType | null;
  partSubType: string | null;
  materialName: string;
  partDimensionsWithOverthickness: FormatterMaterialParameter;
}) => {
  const { customMaterials } = useCustomMaterials({});

  const { recommendedOptions, otherOptions } = getMaterialDimensionsSelectOptions({
    customMaterials,
    materialGrade,
    materialName,
    partType,
    partSubType,
    partDimensionsWithOverthickness,
  });

  return { recommendedOptions, otherOptions, customMaterials };
};
